import { formatCurrency, formatDateTime } from "@/common/utils/formatters"
import ImageWithDisplayName from "@/common/components/ImageWithDisplayName"
import { Link } from "react-router-dom";
import Button from "@/common/components/Button";
import { ArrowBigRightIcon, UserRoundIcon } from "lucide-react";
import TotalValueTableCell from "../components/TableCells/TotalValueTableCell";
import { BankingDepositsData } from "../types/bankingDeposits.type";
import StatusTableCell from "../components/TableCells/StatusTableCell";

export class BankingDepositsTransformer {
  static tableTransformer() {
    return (bankingDeposits: BankingDepositsData[]) => {
      return bankingDeposits.map((bankingDeposit) => {
        return {
          status: <StatusTableCell bankingDeposit={bankingDeposit} />,
          fiscal_document_number: bankingDeposit?.main_fiscal_document?.number || '--',
          created_at: bankingDeposit.created_at && formatDateTime(new Date(bankingDeposit.created_at)),
          requested_by: (bankingDeposit?.requested_by && (
            <ImageWithDisplayName
              displayName={bankingDeposit?.requested_by?.full_name || '--'}
              imageUrl={bankingDeposit?.requested_by?.profile_picture?.url}
              placeholderIcon={UserRoundIcon}
            />
          )) || 'Tcard',
          payment_method: (
            <ImageWithDisplayName
              imageUrl={bankingDeposit.payment.payment_method.icon.url}
              displayName={bankingDeposit.payment.payment_method.display_name}
            />
          ),
          requested_total: bankingDeposit.requested_total && (
            <p className="text-valid">
              {formatCurrency(Number(bankingDeposit.requested_total))}
            </p>
          ),
          total_value: <TotalValueTableCell bankingDeposit={bankingDeposit} />,
          paid_at: bankingDeposit.paid_at && formatDateTime(new Date(bankingDeposit.paid_at)),
          actions: (
            <Link to={bankingDeposit.id}>
              <Button variant="link-white" className="w-full" operationKlassToCheckPermission="Client::Banking::Deposits::Show">
                <ArrowBigRightIcon />
              </Button>
            </Link>
          ),
        }
      });
    }
  }
}
